document.addEventListener('DOMContentLoaded', function () {
  const body = document.querySelector('body');
  const modalOpen = document.querySelectorAll('[data-modal-open]');
  const modalContainer = document.querySelector('[data-modal-container]');
  const modalForm = document.querySelector('[data-modal-form]');
  const modalInput = document.querySelectorAll('[data-modal-input]');
  const modalSubmit = document.querySelector('[data-modal-submit]');
  const modalClose = document.querySelector('[data-modal-close]');

  const section = document.querySelector('.from-trees-ready-to-join');
  const stickyBar = document.querySelector('.from-trees-ready-to-join__sticky-bar');

  modalOpen.forEach(item => {
    item.addEventListener('click', function () {
      modalContainer.classList.add('active');
      body.classList.add('no-scroll');
    })
  });

  modalContainer.addEventListener('click', function (event) {
    if (event.target === modalContainer || event.key === 'Escape' || event.target === modalClose) {
      modalContainer.classList.remove('active');
      body.classList.remove('no-scroll');
    }
  });

  if (section && stickyBar) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('is-visible');
          } else {
            stickyBar.classList.add('is-visible');
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(section);
  }
});